import { Grid, Typography } from '@mui/material';
import React from 'react';

// const TitleIconImageStyle = {
//   height: 20
// };

const AdviserHomePageSubtitle = props => {
  const { title } = props;
  return (
    <Grid container spacing={1} sx={{
      alignItems: "center"
    }}>
      <Grid>
        {/* <img src="img/logo_s_Round.png" alt="portfoplus" style={TitleIconImageStyle} /> */}
        🛠️
      </Grid>
      <Grid>
        <Typography className="subtitle" color="textSecondary">
          {title}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default AdviserHomePageSubtitle;
